import { jsx } from 'react/jsx-runtime';
import { createContext, useId, useMemo } from 'react';

const defaultValues = {};
const InputContext = /*#__PURE__*/ createContext({
    ...defaultValues
});
const InputProvider = ({ children, display = 'fixed', ...propValues })=>{
    const defaultId = useId();
    const ariaIds = useMemo(()=>{
        const id = defaultId;
        const inputMessageId = `${id}-message`;
        const inputLabelId = `${id}-label`;
        return {
            id,
            inputMessageId,
            inputLabelId
        };
    }, [
        defaultId
    ]);
    return jsx(InputContext.Provider, {
        value: {
            ...defaultValues,
            ...propValues,
            display,
            ...ariaIds
        },
        children: children
    });
};
InputProvider.displayName = 'Input.Provider';

export { InputContext, InputProvider };
//# sourceMappingURL=Input.Context.es.js.map
